import { useState, useRef, useEffect } from "react";
import { getFlowDetails } from "../services/newActionServices";
import { OrderByPosition } from "../utils/OrderByPosition";

export function useArticles({pa, order, edsClass, pcd, flow, hfb, store, searchValue}) {
  const [articles, setArticles] = useState([])
  const [articlesSelected, setArticlesSelected] = useState([])
  const [loadingArticles, setLoadingArticles] = useState(false)
  const articlesRef = useRef()

  useEffect(() => {
    if ((pa !== "null" || searchValue !== '') && flow && hfb && store) {
      setArticlesSelected([])
      setLoadingArticles(true)
      const params = {
        flow: flow.id,
        hfb: hfb.id,
        store: store.id,
        pa: (pa?.value === "all" ? "" : pa?.value) ?? "",
        orderby: order.value,
        ascending: 0,
        n_acciones: 5,
        department: "",
        productivityCategory: "",
        eds: (edsClass?.value === "all" ? "" : edsClass?.value) ?? "",
        pcd: pcd.id,
        search: searchValue ?? ''
      }

      getFlowDetails(params)
        .then((details) => {
          setArticles(OrderByPosition(details.data))
          setTimeout(()=>articlesRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100)
        })
        .finally(() => setLoadingArticles(false));
    }
  }, [pa, searchValue, order, edsClass, pcd, flow, hfb, store])

  // clean articles when change pa
  useEffect(()=>{
    if(searchValue === '' && pa === 'null' && !loadingArticles){
      setArticlesSelected([])
      setArticles([])
    }
  },[pa, searchValue, loadingArticles])

  const updateArticleSelected = (e) => {
    setArticlesSelected((prevSelected) => {
      const isSelected = prevSelected.includes(e.target.value);
      return isSelected
        ? prevSelected.filter((id) => id !== e.target.value)
        : [...prevSelected, e.target.value];
    })
  }
  const updateArticleSelectedFromSearch = (e) => {
    setArticlesSelected([e.value])
  }

  const articlesToSelectFormatted = articles.map((article)=>({...article,  value: article.articleNumber,
      label: `${article.articleNumber} - ${article.itemInfoDTO.description}`}))
  

  return {
    articles,
    setArticles,
    articlesToSelectFormatted,
    articlesSelected,
    updateArticleSelectedFromSearch,
    updateArticleSelected,
    articlesRef,
    loadingArticles,
  }
}
